// Transactions slice
import { StateCreator, StoreApi } from "zustand";
import { TransactionExtended } from "@/types";
import { AppStoreState } from "../appStore";
type SetState = StoreApi<AppStoreState>["setState"];
type GetState = StoreApi<AppStoreState>["getState"];

const createTransactionsSlice: StateCreator<
  AppStoreState,
  [],
  [],
  Pick<AppStoreState, "transactions" | "setTransactions">
> = (set: SetState, get: GetState) => ({
  transactions: [],
  setTransactions: (transactions: TransactionExtended[]) =>
    set({ transactions }),
  setTransactionStatus: async (
    transactionId: string,
    workflowStatus: string
  ) => {
    const response = await fetch("/api/transaction/update/status", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ transactionId, workflowStatus }),
    });
    const data = await response.json();
    if (data.ok && data.transaction) {
      set((state: AppStoreState) => {
        if (!state.user) return {};
        const updatedTransactions = (
          state.user.selectedReport?.transactions ?? []
        ).map((t) => (t.id === transactionId ? { ...t, workflowStatus } : t));
        return {
          user: {
            ...state.user,
            selectedReport: {
              ...state.user.selectedReport,
              transactions: updatedTransactions,
            },
          },
        } as Partial<AppStoreState>;
      });
    }
    return data;
  },
  setTransactionPurpose: async (transactionId: string, purpose: string) => {
    const response = await fetch("/api/transaction/update/purpose", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ transactionId, purpose }),
    });
    const data = await response.json();
    if (data.ok && data.transaction) {
      set((state: AppStoreState) => {
        if (!state.user) return {};
        const updatedTransactions = (
          state.user.selectedReport?.transactions ?? []
        ).map((t) => (t.id === transactionId ? { ...t, purpose } : t));
        return {
          user: {
            ...state.user,
            selectedReport: {
              ...state.user.selectedReport,
              transactions: updatedTransactions,
            },
          },
        } as Partial<AppStoreState>;
      });
    }
    return data;
  },
  setTransactionInvoice: async (transactionId: string, invoiceId: string) => {
    const response = await fetch("/api/transaction/update/invoice", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ transactionId, invoiceId }),
    });
    const data = await response.json();
    if (data.ok && data.transaction) {
      set((state: AppStoreState) => {
        if (!state.user) return {};
        const updatedTransactions = (
          state.user.selectedReport?.transactions ?? []
        ).map((t) =>
          t.id === transactionId
            ? { ...t, invoiceIds: [...(t.invoiceIds ?? []), invoiceId] }
            : t
        );
        return {
          user: {
            ...state.user,
            selectedReport: {
              ...state.user.selectedReport,
              transactions: updatedTransactions,
            },
          },
        } as Partial<AppStoreState>;
      });
    }
    return data;
  },
  setTransactionNote: async (transactionId: string, note: string) => {
    const response = await fetch("/api/transaction/update/note", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ transactionId, note }),
    });
    const data = await response.json();
    if (data.ok && data.transaction) {
      set((state: AppStoreState) => {
        if (!state.user) return {};
        const updatedTransactions = (
          state.user.selectedReport?.transactions ?? []
        ).map((t) => (t.id === transactionId ? { ...t, note } : t));
        return {
          user: {
            ...state.user,
            selectedReport: {
              ...state.user.selectedReport,
              transactions: updatedTransactions,
            },
          },
        } as Partial<AppStoreState>;
      });
    }
    return data;
  },
});

export default createTransactionsSlice;
